import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  getCompanyOnboarding: companyId => makeAxiosRequest(`/onboarding/${companyId}`, { method: 'get' }, true),
  updateCompanyOnboarding: companyId => makeAxiosRequest(`/onboarding/${companyId}`, { method: 'post' }, true),
};
